<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-xl" @reset="reset">
                <template v-slot:filter>

                </template>
                <template v-slot:page>
                    <select v-model="form.length" class="form-select w-20">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="200">200</option>
                    </select>
                </template>
                <template v-slot:status>

                </template>
            </search-filter>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <thead>
                    <tr class="text-left font-bold">
                        <th class="pb-2 pt-3 px-3 text-center" width="20">Sl.</th>
                        <th class="pb-2 pt-3 px-3">Number</th>
                        <th class="pb-2 pt-3 px-3">SMS</th>
                        <th class="pb-2 pt-3 px-3">Return message</th>
                        <th class="pb-2 pt-3 px-3 text-center">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(log, index) in smsLogs.data" :key="log.id"
                        class="hover:bg-gray-100 focus-within:bg-gray-100">
                        <td class="border-t pbamenity-1 pt-1 px-3 text-center">
                            {{ index + smsLogs.from }}
                        </td>
                        <td class="border-t pb-1 pt-1 px-3">
                            {{ log.number }}

                        </td>
                        <td class="border-t pb-1 pt-1 px-3" style="width: 50%; line-height: normal;">
                            <div class="whitespace-normal break-words">
                                {{ log.sms_body }}
                            </div>
                        </td>
                        <td class="border-t pb-1 pt-1 px-3">
                            <div class="truncate max-w-xs">
                                {{ log.return_message }}
                            </div>
                        </td>

                        <td class="border-t pb-1 pt-1 px-3 text-center">
                            <status-level :status="log.status_id"></status-level>
                        </td>

                    </tr>
                    <tr v-if="smsLogs.data.length === 0">
                        <td class="px-6 py-4 border-t" colspan="4">No Data found.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <pagination class="mt-6" :links="smsLogs.links" />
    </div>
</template>
<script>
import Breadcrumbs from "@/Shared/Breadcrumbs";
import Button from "@/Shared/Button";
import Icon from "@/Shared/Icon";
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import SearchFilter from "@/Shared/SearchFilter";
import StatusLevel from "@/Shared/StatusLevel";
import { Head, Link } from "@inertiajs/inertia-vue3";
import mapValues from "lodash/mapValues";
import pickBy from "lodash/pickBy";
import throttle from "lodash/throttle";
import { ref, toRefs, inject } from "vue";

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
        Breadcrumbs,
        StatusLevel,
        Button,
    },
    layout: Layout,
    props: {
        filters: Object,
        permission: Object,
        smsLogs: Object,
    },
    setup(props) {
        const { filters, smsLogs, permission } = toRefs(props);
        const form = ref({
            search: filters.value.search,
            trashed: filters.value.trashed,
            length: filters.value.length ? filters.value.length : 15,
            status: filters.value.status,
        });
        const type = ref("index");
        const title = ref("SMS Logs");
        const url = ref("");
        const createUrl = ref("/backend/sms-logs/create");
        const reset = () => {
            form.value = mapValues(form, () => null);
        };
        return {
            filters,
            smsLogs,
            form,
            type,
            title,
            url,
            createUrl,
            reset,
            permission,
        };
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get("/backend/sms-logs", pickBy(this.form), {
                    preserveState: true,
                });
            }, 150),
        },
    },
};
</script>

<style scoped>
.table-container {
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}
.table {
    width: 100%;
    border-collapse: collapse;
}
.table th {
    background-color: #4a5568;
    color: #ffffff;
    font-weight: bold;
    text-align: left;
    padding: 12px;
}
.table td {
    padding: 12px;
    border-top: 1px solid #e2e8f0;
}
.table tr:hover {
    background-color: #edf2f7;
}
.table .text-center {
    text-align: center;
}
.table .status-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #38a169;
}
.table .status-icon.error {
    background-color: #e53e3e;
}
.table .status-icon.pending {
    background-color: #d69e2e;
}
</style>
